import { createSelector } from 'reselect';

const formDataSelector = (formStore, type) => formStore?.formData[type]

export const getFormDataSelector = createSelector(
    formDataSelector,
    (formData) => formData
);

const formPropertiesSelector = (formStore) => formStore?.formProperties

export const getFormPropertiesSelector = createSelector(
    formPropertiesSelector,
    (formProperties) => formProperties
);

const formServiceSelector = (formStore, serviceType) => formStore?.formServices[serviceType]

export const getFormServiceStatusSelector = createSelector(
    formServiceSelector,
    (formService) => formService
);

const formCalcFieldSelector = (formStore, type) => formStore?.formData['genericFormData']?.calcs?.find(element => element.id === type)

export const getFormCalcFieldSelector = createSelector(
    formCalcFieldSelector,
    (calculatedValue) => calculatedValue
);

const referenceDataselector = (state, type) => state.referenceData[type]

export const getReferenceDataSelector = createSelector(
    referenceDataselector,
    (referenceData) => referenceData
);